<template>
	<tr class="no-click">
		<td>{{ item.name }}</td>
		<td>{{ item.expected_quantity }}</td>
		<td>
			<template v-if="!openForm">
				<template v-if="result == null || result == undefined">
					<v-btn
						color="secondary"
						@click="
							$emit('set-result', {
								target_id: item.target_id,
								target_type: item.target_type,
								quantity: item.expected_quantity,
							})
						"
						icon
						><v-icon>mdi-checkbox-marked</v-icon></v-btn
					>
					<v-btn
						v-if="
							inventory_type !== 'product_order_individual_info' &&
							inventory_type !== 'wip_order_individual_info'
						"
						color="red"
						@click="openForm = true"
						icon
						><v-icon>mdi-close-circle</v-icon></v-btn
					>
				</template>
				<template v-else>
					<v-row no-gutters justify="space-between" align="center" class="flex-nowrap">
						<p>
							{{ result.quantity }}
						</p>
						<v-btn
							v-if="
								inventory_type !== 'product_order_individual_info' &&
								inventory_type !== 'wip_order_individual_info'
							"
							@click="openForm = true"
							icon
							><v-icon>mdi-pencil</v-icon></v-btn
						>
					</v-row>
				</template>
			</template>
			<template v-else>
				<v-form v-model="valid">
					<v-row no-gutters class="flex-nowrap">
						<v-text-field
							class="mt-2 append-outer"
							label="実際の数を入力"
							dense
							outlined
							v-model="input_quantity"
							:rules="[rules.required, numberRule()]"
							type="number"
						>
							<template v-slot:append-outer>
								<v-btn color="secondary" icon @click="submitForm()" :disabled="!valid"
									><v-icon>mdi-content-save-outline</v-icon></v-btn
								>
							</template>
						</v-text-field>
					</v-row>
				</v-form>
			</template>
		</td>
		<td>{{ result ? result.user.full_name : "" }}</td>
	</tr>
</template>

<script>
import rules from "../../../helper/rules"

export default {
	props: {
		item: {
			type: Object,
			required: true,
		},
		result: {
			type: null,
			required: false,
			default: null,
		},
		quantity_type: {
			type: String,
			required: null,
		},
		inventory_type: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			valid: false,
			openForm: false,
			input_quantity: null,
			rules,
		}
	},
	methods: {
		numberRule() {
			if (this.quantity_type == "integer") {
				return rules.integerWithNegative
			} else if (this.quantity_type == "float") {
				return rules.floatWithNegative
			}
		},
		submitForm() {
			this.$emit("set-result", {
				target_id: this.item.target_id,
				target_type: this.item.target_type,
				quantity: this.input_quantity,
			})
			this.openForm = false
		},
	},
	watch: {
		result(val) {
			if (val) {
				this.input_quantity = val.quantity
			}
		},
	},
}
</script>
